/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Rodzaj dokumentu prawnego
 * @export
 * @enum {string}
 */

export const LegalDocumentTypeDto = {
    TermsOfUse: 'TERMS_OF_USE',
    PrivacyPolicy: 'PRIVACY_POLICY'
} as const;

export type LegalDocumentTypeDto = typeof LegalDocumentTypeDto[keyof typeof LegalDocumentTypeDto];



